import registerComponents from './components'

const pageContent = document.querySelector('#main-content main > div')
if (pageContent) {
  document.addEventListener('DOMContentLoaded', () => {
    registerComponents()
      .forEach((component) => {
        const tag = `cozy-${component.is}`
        const regex = new RegExp(`\\[${component.is}:(.*?)\\]`, 'g')
        pageContent.innerHTML = pageContent.innerHTML.replace(regex, (_, content) =>
          `<${tag}>${content.trim()}</${tag}>`
        )
      })
  })
}

const extraStyles = document.createElement('style')
extraStyles.innerHTML = `
  table td:nth-child(-n+2) cozy-price::part(image) {
    height: 1.5em;
  }
  .page-content table {
    width: 100%;
  }
`
document.head.appendChild(extraStyles)
